import SNACKBAR_ALERT_CLASS_NAME from '../../constants/alert';

export const snackbarAlert = ({ theme }) => ({
  width: '100%',
  padding: '12px 16px',
  backgroundColor: theme.palette.contrast.A700,
  borderRadius: 8,
  '& .MuiAlert-icon': {
    p: 0,
    mr: 1.5,
    opacity: 1,
  },
  '& .MuiAlert-message': {
    ...theme.typography.small_2,
    color: theme.palette.common.white,
    fontWeight: 600,
  },
});

const MuiAlert = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${SNACKBAR_ALERT_CLASS_NAME}`]: snackbarAlert({ theme }),
    }),
  },
};

export default MuiAlert;
